import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SkeletonTable } from '../../../components/common/SkeletonLoader';
import { referralDetailPath } from '../../../utils/partnerPortal';
import { ReferralsTable } from '../ReferralsTable';
import { usePartnerPortalContext } from '../portalContext';

const ClientsTab: React.FC = () => {
  const navigate = useNavigate();
  const { referrals, partners, truncated, loading, referralsError, hideFees } = usePartnerPortalContext();

  return (
    <section className="space-y-3">
      <div className="flex items-baseline justify-between gap-3">
        <h2 className="text-base font-semibold text-gray-100">My clients</h2>
        {!loading && referrals.length > 0 && <span className="text-xs text-gray-400">{referrals.length} sent</span>}
      </div>

      {loading ? (
        <SkeletonTable rows={3} columns={5} />
      ) : referralsError ? (
        <div className="rounded-lg border border-red-500/40 bg-red-500/10 px-4 py-3 text-sm text-red-300" role="alert">
          Could not load your referrals. {referralsError}
        </div>
      ) : referrals.length === 0 ? (
        <div className="rounded-xl border border-dashed border-gray-700 px-6 py-10 text-center">
          <p className="text-sm font-medium text-gray-200">No referrals yet</p>
          <p className="mt-1 text-sm text-gray-400">
            {hideFees
              ? 'Clients you refer appear here with their stage.'
              : 'Clients you refer appear here with their stage and the fee owed on settlement.'}
          </p>
        </div>
      ) : (
        <>
          <ReferralsTable
            referrals={referrals}
            partners={partners}
            hideFees={hideFees}
            onSelect={(id) => navigate(referralDetailPath(id))}
          />
          {truncated && <p className="text-xs text-gray-400">Showing your 500 most recent referrals.</p>}
        </>
      )}
    </section>
  );
};

export default ClientsTab;
